import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HttpServices } from "./httpservices/http.service";

import { Md5 } from 'ts-md5/dist/md5';

import { GlobalVariable } from '../app.globalvariable';
import { CommonEncrypt } from "../utils/common.encrypt";
import { SampleInfo } from "../model/sampleInfo.model";
@Injectable()

export class StudyService {



    constructor(private datasource: HttpServices) { }



    // random(): Observable<string> {

    //     this.datasource.random().subscribe(p => {
    //         console.log(p);
    //         if (p.status == '1') {
    //             //通知重新更新列表
    //             GlobalVariable.setMacKey(p.resultInfo.macKey);
    //             GlobalVariable.setSessionID(p.resultInfo.sessionID);
    //         }
    //     })

    //     return null;
    // }

    init(initInfo: SampleInfo): Observable<string> {

  
        return this.datasource.studyInit(initInfo);

    }



    get authenticated(): boolean {

        return GlobalVariable.getAuthToken() != null;

    }

    getMacKey() {
        return GlobalVariable.getMacKey();
    }

    clear() {

        GlobalVariable.setAuthToken(null);

    }

}